'use client'

import SvgCheck from '@/icons/thin/Check'

interface GeneralPopupListProps {
  title: string | null
  items: string[]
}

export const GeneralPopupList = ({ title, items }: GeneralPopupListProps) => {
  if (items.length === 0) {
    return null
  }

  return (
    <div className="hidden md:block">
      {title ? <h3 className="text-navy mb-3 text-xs font-bold tracking-wider uppercase">{title}</h3> : null}
      <ul className="space-y-2.5">
        {items.map((item, index) => (
          <li
            key={`${index}-${item}`}
            className="text-base-minus flex items-center gap-2.5 font-medium text-slate-600 md:text-sm"
          >
            <SvgCheck className="h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
